import {
  type PluginKey,
  type PluginsChecker,
  type PluginsState,
} from '@databases/plugins-types';

export class PluginsManager implements PluginsChecker {
  #pluginsState: PluginsState;

  constructor(plugins: PluginsState) {
    this.#pluginsState = { ...plugins };
  }

  isPluginEnabled(pluginKey: PluginKey): boolean {
    const callback = this.#pluginsState[pluginKey];
    return callback ? callback() : false;
  }
}
